import { useQuery } from '@tanstack/react-query'
import { fetchProjects, isProjectsApiAvailable } from '@/services/projects/projectsApi'
import { workspaceScopedKey } from '@/services/workspaces/workspaceQueryKeys.js'
import { getActiveWorkspaceId } from '@/store/workspaceStore'

export function backendProjectsQueryKey() {
  return workspaceScopedKey(['do-chat', 'projects'])
}

export function useBackendProjects() {
  const workspaceId = getActiveWorkspaceId()
  return useQuery({
    queryKey: backendProjectsQueryKey(),
    queryFn: ({ signal }) => fetchProjects({ signal }),
    enabled: isProjectsApiAvailable() && Boolean(workspaceId),
    retry: false,
  })
}

export function backendProjectsForNav(query) {
  return query.isSuccess ? query.data ?? [] : undefined
}
